import React from 'react';
import PropTypes from 'prop-types';
import ActivePokemon from '../ActivePokemon';
import BenchSlot from '../Bench/BenchSlot';
import Deck from '../Deck';
import DiscardPile from '../DiscardPile';
import PrizeSlot from '../Prizes/PrizeSlot';
import { BENCH_POSITIONS, MAT_SPOTS } from './layout';
import { Half, Mat, MatPhoto, Spot } from './styled';

const at = ([left, top]) => ({ left: `${left}%`, top: `${top}%` });

/** One player's cards in their spots on their half of the mat. */
const MatHalf = ({ userId, opponent }) => (
  <Half $opponent={opponent} data-side={opponent ? 'opponent' : 'player'}>
    {MAT_SPOTS.prizes.map((spot, position) => (
      <Spot key={`prize-${position}`} style={at(spot)} data-zone="prize"><PrizeSlot userId={userId} position={position} /></Spot>
    ))}
    <Spot style={at(opponent ? MAT_SPOTS.opponentActive : MAT_SPOTS.active)} data-zone="active"><ActivePokemon userId={userId} /></Spot>
    {BENCH_POSITIONS.map(position => (
      <Spot key={`bench-${position}`} style={at(MAT_SPOTS.bench[position])} data-zone="bench">
        <BenchSlot userId={userId} position={position} />
      </Spot>
    ))}
    <Spot style={at(MAT_SPOTS.deck)} data-zone="deck"><Deck userId={userId} /></Spot>
    <Spot style={at(MAT_SPOTS.discard)} data-zone="discard"><DiscardPile userId={userId} /></Spot>
  </Half>
);

MatHalf.propTypes = {
  userId: PropTypes.number.isRequired,
  opponent: PropTypes.bool,
};

/**
 * The game on the original playmat photo. Your half is at the bottom; the opponent's is turned to face them, the way
 * it would across a table.
 */
const MatBoard = ({ playerId, opponentId, turned }) => (
  <Mat>
    <MatPhoto $turned={turned} />
    <MatHalf userId={opponentId} opponent />
    <MatHalf userId={playerId} />
  </Mat>
);

MatBoard.propTypes = {
  playerId: PropTypes.number.isRequired,
  opponentId: PropTypes.number.isRequired,
  turned: PropTypes.bool,
};

export default MatBoard;
